import { classResponsiveForm, classResponsiveFormDoubleWidth, classResponsiveFormDoubleWidthHeader } from "src/data/ConstantForm";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import { patterDocument, patterEmail, patterPhone } from "src/util/is";
import { usuariosService } from "src/services/unoauno/apiUsuarios";
import { modalCRUDService } from "src/services/modalCRUDService";
import { GlobalConstants } from "src/data/GlobalConstants";
import { FormProvider, useForm } from "react-hook-form";
import { Colors } from "src/assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import { useDispatch } from "react-redux";


const ProfileCRUD = ({properties}) => { 
    
    const dispatch = useDispatch();

    
    const {idRol, nbDocumento, txCorreo, nbTelefono, txVersion,idBusqueda,idTendero, reload} = properties;    
    
    const fechaAux = new Date();
    const methods = useForm({defaultValues: {
        fecha: [new Date(fechaAux.getFullYear(), fechaAux.getMonth(), 1), fechaAux],
        nbDocumento: nbDocumento,
        txCorreo: txCorreo,
        nbTelefono: nbTelefono,
        idRol: idRol,
        ultimaVersion: txVersion
    }});
    const { control,getValues, handleSubmit, formState: { errors } } = methods;

    const onSubmitUser = async () => {
        const nbDocumentoTrimmed = getValues("nbDocumento").trim();
        const txCorreoTrimmed = getValues("txCorreo").trim();
        const nbTelefonoTrimmed = getValues("nbTelefono").trim();

        if(!patterEmail.test(txCorreoTrimmed)) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Correo invalido, no puede contener espacios' } });
            return;
        }

        if(!patterDocument.test(nbDocumentoTrimmed)) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Documento invalido, no puede contener espacio' } });
            return;
        }

        if(!patterPhone.test(nbTelefonoTrimmed)) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Telefono invalido, no puede contener espacio' } });
            return;
        }

        try {
            const res = await usuariosService.VerifyInfo({idBusqueda,nbDocumento:nbDocumentoTrimmed, txCorreo:txCorreoTrimmed, nbTelefono:nbTelefonoTrimmed, idTendero});
            if(!res.status){
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: res.msg } });
                return;
            }
            await usuariosService.updateUserProfile({idBusqueda,nbDocumento:nbDocumentoTrimmed, txCorreo:txCorreoTrimmed, nbTelefono:nbTelefonoTrimmed, idTendero});
            reload();
            modalCRUDService.clear();
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
        } catch (error) {
            console.log(error); 
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Presentas un error, comunicate con soporte' } });
        }

    }

    
    
  return (
    <FormProvider {...methods}>
    <div className="w-100 px-4">
        <strong>Actualizar informacion</strong>
        <div className="w-100 row m-0 d-flex px-2" style={{gap: "7px"}}>

        <InputForm
            identificador="UserRol" 
            label="Rol"
            placeholder=""
            value={idRol}
            required={false}
            textUppercase={false}
            className={`${classResponsiveForm}`}
            disabled={true}
        />
        <InputForm
        inputProps={{control}} 
            identificador="nbDocumento" 
            label="Documento"
            placeholder=""
            value={nbDocumento}
            required={false}
            textUppercase={false}
            className={`${classResponsiveForm}`}
            disabled={idBusqueda==1}
        />

         <InputForm
            inputProps={{control}} 
             identificador="txCorreo" 
             label="Correo"
             placeholder=""
             value={txCorreo}
             required={false}
             textUppercase={false}
             className={`${classResponsiveFormDoubleWidthHeader}`}
             disabled={idBusqueda==3}
         />
    
            <div className="row m-0 mt-2 d-flex align-items-center">
                <InputForm
                    inputProps={{control}} 
                    identificador="nbTelefono" 
                    label="Teléfono"
                    placeholder=""
                    value={nbTelefono}
                    required={false}
                    textUppercase={false}
                    className={`${classResponsiveFormDoubleWidth}`}
                    disabled={idBusqueda==2}
                />
            <InputForm
                identificador="ultimaVersion" 
                label="Ultima Versión"
                placeholder=""
                value={txVersion}
                required={false}
                textUppercase={false}
                className={`${classResponsiveFormDoubleWidthHeader}`}
                disabled={true}
                />
            <Tooltip className="ml-2" title="Guardar" aria-label="guardar">
                <a onClick={handleSubmit(onSubmitUser,()=>{})} className="icon-container-actions d-flex">
                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                </a>
            </Tooltip>
            </div>
    </div>
    </div>
</FormProvider>
  )
}

export default ProfileCRUD